import { MtGroup, MtUser } from "server/models"
import { OrderType } from "client/utils"
import { GroupFilters, UserFilters } from "client/store"


export interface UserGroupProps {
    accountId: number
    userId: number
}

export interface UserGroupList { [userId: number]: readonly number[]}
export interface AccountGroupList { [accountId: number]: readonly number[]}
export interface GroupUserList { [groupId: number]: readonly number[]}

export interface UserGroupState {
    userGroupList: UserGroupList
    accountGroupList: AccountGroupList
    groupUserList: GroupUserList

    assignedGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtGroup
        sortOrder: OrderType
        filters: GroupFilters
    }
    notAssignedGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtGroup
        sortOrder: OrderType
        filters: GroupFilters
        selected: readonly number[]
    }

    assignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
    }
    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    reloadUserGroupList: boolean
    reloadGroupUserList: boolean
}

export const USER_GROUP_LIST = "USER_GROUP_LIST"
export const ACCOUNT_GROUP_LIST = "ACCOUNT_GROUP_LIST"
export const GROUP_USER_LIST = "GROUP_USER_LIST"

export const ASSIGNED_USER_GROUP_IDS = "ASSIGNED_USER_GROUP_IDS"
export const ASSIGNED_USER_GROUP_SORT = "ASSIGNED_USER_GROUP_SORT"
export const ASSIGNED_USER_GROUP_FILTERS = "ASSIGNED_USER_GROUP_FILTERS"

export const NOT_ASSIGNED_USER_GROUP_IDS = "NOT_ASSIGNED_USER_GROUP_IDS"
export const NOT_ASSIGNED_USER_GROUP_SORT = "NOT_ASSIGNED_USER_GROUP_SORT"
export const NOT_ASSIGNED_USER_GROUP_FILTERS = "NOT_ASSIGNED_USER_GROUP_FILTERS"
export const NOT_ASSIGNED_USER_GROUP_SELECTED = "NOT_ASSIGNED_USER_GROUP_SELECTED"

export const ASSIGNED_GROUP_USER_IDS = "ASSIGNED_GROUP_USER_IDS"
export const ASSIGNED_GROUP_USER_SORT = "ASSIGNED_GROUP_USER_SORT"
export const ASSIGNED_GROUP_USER_FILTERS = "ASSIGNED_GROUP_USER_FILTERS"

export const NOT_ASSIGNED_GROUP_USER_IDS = "NOT_ASSIGNED_GROUP_USER_IDS"
export const NOT_ASSIGNED_GROUP_USER_SORT = "NOT_ASSIGNED_GROUP_USER_SORT"
export const NOT_ASSIGNED_GROUP_USER_FILTERS = "NOT_ASSIGNED_GROUP_USER_FILTERS"
export const NOT_ASSIGNED_GROUP_USER_SELECTED = "NOT_ASSIGNED_GROUP_USER_SELECTED"

export const USER_GROUP_RELOAD_LIST = "USER_GROUP_RELOAD_LIST"
export const GROUP_USER_RELOAD_LIST = "GROUP_USER_RELOAD_LIST"
